<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';

export default {
  name: 'AttemptsValidationDataView',
  extends: DataViewListVue,
  data: (vm) => ({
    content: [
      {
        value: 'attemptsFaceMatch',
        text: 'Tentativas de reconhecimento facial',
        handle: vm.addMoreOne,
      },
      {
        value: 'attemptsOcrDocument',
        text: 'Tentativas de validação de documentos',
        handle: vm.addMoreOne,
      },
      {
        value: 'attemptsPersonalData',
        text: 'Tentativas de validação de dados',
        handle: vm.addMoreOne,
      },
    ],
  }),
  methods: {
    addMoreOne(key) {
      return String(this.handleProperty(key));
    },
  },
};
</script>
